var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBell = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(-1112.000000, -48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1112.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88576355,3.343125 C5.31817734,3.343125 1.60231527,6.879 1.60231527,11.2253437 L1.60231527,19.5967969 L3.31610837,19.5967969 L3.31610837,11.2253437 C3.31610837,7.77839063 6.26300493,4.97390625 9.88576355,4.97390625 C13.5085222,4.97390625 16.4554187,7.77834375 16.4554187,11.2253437 L16.4554187,19.5967969 L18.1692611,19.5967969 L18.1692611,11.2253437 C18.1692611,6.879 14.4533498,3.343125 9.88576355,3.343125 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1403448,18.7814062 L0.859655172,18.7814062 C0.38635468,18.7814062 0.00275862069,19.1464219 0.00275862069,19.5967969 C0.00275862069,20.0471719 0.38635468,20.4121875 0.859655172,20.4121875 L19.1403941,20.4121875 C19.6136946,20.4121875 19.9972906,20.0471719 19.9972906,19.5967969 C19.9972906,19.1464219 19.6136453,18.7814062 19.1403448,18.7814062 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88576355,0 C8.43674877,0 7.25793103,1.12171875 7.25793103,2.50054687 C7.25793103,3.879375 8.43674877,5.00109375 9.88576355,5.00109375 C11.3347783,5.00109375 12.5135961,3.879375 12.5135961,2.50054687 C12.5135961,1.12171875 11.3347783,0 9.88576355,0 Z M9.88576355,3.3703125 C9.39019704,3.3703125 8.97172414,2.971875 8.97172414,2.50054687 C8.97172414,2.02898437 9.39019704,1.63078125 9.88576355,1.63078125 C10.38133,1.63078125 10.799803,2.02898437 10.799803,2.50054687 C10.799803,2.97210938 10.38133,3.3703125 9.88576355,3.3703125 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3710345,19.5968438 L11.3710345,21.0102187 C11.3710345,21.7595625 10.7303448,22.3692188 9.94285714,22.3692188 C9.15536946,22.3692188 8.5146798,21.7595625 8.5146798,21.0102187 L8.5146798,19.5968438 L6.80083744,19.5968438 L6.80083744,21.0102187 C6.80083744,22.6586719 8.21044335,24.0000469 9.94285714,24.0000469 C11.6752217,24.0000469 13.0848768,22.6587187 13.0848768,21.0102187 L13.0848768,19.5968438 L11.3710345,19.5968438 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell.01217ab2ba085e1fc96ce28c3b782679.svg";